import http from '@monolith/legacy/services/api/http';
import { OrderBrandRejectionType } from '@monolith/legacy/types/order-brand-rejection';

export const rejectOrder = (orderId: number, rejectReason: OrderBrandRejectionType): Promise<void> => {
  return http().post(`/api/orders/${orderId}/cancel`, {
    reject_type: rejectReason,
  });
};
